import { administrationRequests } from "api/administrationApi";
import { createExporter } from "utils/createExporter";
import { STUDENTS, CANDIDATE_USERS } from "utils/constants";
import { determineGender } from "utils/helpers";
import { accountRequests } from "api/accountApi";

const COMMON_COLUMNS = [
  { key: "firstName", label: "име" },
  { key: "secondName", label: "презиме" },
  { key: "lastName", label: "фамилия" },
];

const CANDIDATE_COLUMNS = [
  { key: "personId", label: "ЕГН" },
  ...COMMON_COLUMNS,
  { key: "gender", label: "пол" },
  { key: "email", label: "имейл" },
  { key: "externalEmail", label: "Google имейл" },
  { key: "contactPhone", label: "телефонен номер" },
  { key: "citizenship", label: "гражданство" },
];

const STUDENT_COLUMNS = [
  ...COMMON_COLUMNS,
  { key: "facultyNumber", label: "факултетен номер" },
  { key: "speciality", label: "специалност" },
  { key: "course", label: "курс" },
  { key: "instructionLanguage", label: "език на обучение" },
  { key: "studyGroup", label: "учебна група" },
];

export const UsersExporter = type => {
  const columnsMap = {
    [STUDENTS]: STUDENT_COLUMNS,
    [CANDIDATE_USERS]: CANDIDATE_COLUMNS,
  };

  const mapperMap = {
    [STUDENTS]: record => ({
      ...record,
      firstName: record.user?.firstName,
      secondName: record.user?.secondName,
      lastName: record.user?.lastName,
      speciality: record.speciality?.name,
      instructionLanguage: record.instructionLanguage?.name,
    }),

    [CANDIDATE_USERS]: record => ({
      ...record,
      gender: determineGender(record.gender),
      citizenship: record.citizenship?.name,
    }),
  };

  const relationMap = {
    [CANDIDATE_USERS]: [
      {
        source: "citizenshipId",
        target: administrationRequests.getCitizenshipSelect(),
        name: "citizenship",
      },
    ],

    [STUDENTS]: [
      {
        source: "userId",
        target: accountRequests.getUsersSelect(),
        name: "user",
      },
      {
        source: "specialityId",
        target: administrationRequests.getSpecialitiesSelect(),
        name: "speciality",
      },
      {
        source: "instructionLanguageId",
        target: administrationRequests.getInstructionLanguagesSelect(),
        name: "instructionLanguage",
      },
    ],
  };

  const columns = columnsMap[type];

  const mapper = mapperMap[type] || (r => r);

  const relation = relationMap[type] || [];

  const fileName = type === STUDENTS ? "students" : "candidates";

  return createExporter(`users_${fileName}.xlsx`, columns, mapper, relation);
};
